import { useEffect } from "react";
import { useAtom } from "jotai";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useUser } from "@/hooks/useUser";
import { onboardingAtom } from "@/state/onboarding";
import { PATHS } from "@/config/paths";

export const Route = createFileRoute("/dashboard/newUser")({
  component: NewUserPage,
});

function NewUserPage() {
  const { isAuthenticated } = useUser();
  const [onboarding, setOnboarding] = useAtom(onboardingAtom);

  const router = useRouter();

  // Handle confetti for new users
  useEffect(() => {
    if (isAuthenticated) {
      setOnboarding({
        ...onboarding,
        step: "profileSetup",
        selectedHealthAreas: onboarding.selectedHealthAreas,
      });

      router.navigate({ to: PATHS.DASHBOARD });
    }
    // Do not add onboarding as a dependency because it will cause a re-render
  }, [router, isAuthenticated, setOnboarding]);

  return null;
}
